module.exports = {
  messages: {
    CN: {
      inquiryList: {
        askPriceNoKeyword: "询价编号",
        erpCustomerKeyword: "得意先情報",
        sellerCode: "担当者",
        date: "询价时间",
        askPriceNoKeywordPH: "请输入询价编号",
        erpCustomerKeywordPH: "得意先名/得意先コード",
        sellerCodePH: "選択してください",
        startDatePH: "開始時間",
        endDatePH: "終了時間",
        askPriceNo: "询价编号",
        erpCustomerName: "得意先情報",
        createTime: "询价时间",
        sellerName: "担当者",
        status: "询价状态",
        action: "操作",
        submitted: "已提交",
        completed: "询价完成",
        detail: "詳細"
      },
      inquiryDetail: {
        info: "询价信息",
        product: "商品明细",
        baseInfo: "基本情報",
        customerNote: "得意先備考",
        productNo: "商品コード",
        productName: "商品名",
        sellWay: "販売方法",
        salePrice: "販売価格",
        productNum: "商品数量",
        transportName: '運輸',
        chineseName: "中国語名",
        rongliang: "容量",
        rushu: "入数",
        brand: "ブランド",
        source: "原産地",
        totalBox: "ケース販売",
        sanBox: "バラ"
      }
    },
    JP: {
      inquiryList: {
        askPriceNoKeyword: "見積依頼番号",
        erpCustomerKeyword: "得意先情報",
        sellerCode: "担当者",
        date: "見積依頼日時",
        askPriceNoKeywordPH: "見積依頼番号を入力してください",
        erpRequestPriceKeywordPH: "見積書番号を入力してください",
        erpCustomerKeywordPH: "得意先名/得意先コード",
        sellerCodePH: "選択してください",
        startDatePH: "開始時間",
        endDatePH: "終了時間",
        askPriceNo: "見積依頼番号",
        erpCustomerName: "得意先情報",
        createTime: "見積依頼日時",
        sellerName: "担当者",
        status: "询价状态",
        action: "操作",
        submitted: "已提交",
        completed: "询价完成",
        detail: "詳細",
        "amount": '合计金额',
        quoteNo: '見積No',
        quoteTime: '見積日',
        linkRequest: '关联見積依頼',
        linkErpRequest: '关联見積書',
        comment: '備考',
        validDate: '有効期限',
        naDate: '納期',
        syncQuote: '見積書を同期する',
        notifyOrNot: "通知を送信しますか",
        sendNotify: "通知送信",
        notifySuccess: "通知送信成功",
        notifyVersion: "通知履歴",
        sender: "送信者",
        sendTime: "送信時間",
        sendVersion: "バージョン番号"
      },
      inquiryDetail: {
        info: "見積情報",
        info2: "見積書情報",
        product: "商品明細",
        baseInfo: "基本情報",
        customerNote: "得意先備考",
        productNo: "商品コード",
        productName: "商品名",
        sellWay: "販売方法",
        salePrice: "販売価格",
        productNum: "商品数量",
        transportName: '運輸',
        chineseName: "中国語名",
        rongliang: "容量",
        rushu: "入数",
        brand: "ブランド",
        source: "原産地",
        totalBox: "ケース販売",
        sanBox: "バラ"
      }
    }
  }
};